import axios from "axios";

const API = axios.create({
  baseURL: "/api",
});

// attach token
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

// CREATE LEAD
export const createLeadApi = (data) =>
  API.post("/leads", data);

// GET LEADS
export const getLeadsApi = () =>
  API.get("/leads");

// GET SINGLE LEAD
export const getLeadByIdApi = (id) =>
  API.get(`/leads/${id}`);

// UPDATE STATUS
export const updateLeadStatusApi = (id, data) =>
  API.put(`/leads/${id}`, data);

export const assignLeadApi = (id, email) =>
  API.put(`/leads/assign/${id}`, { email });

// 🔥 NEW: BULK ASSIGN LEADS (ADMIN)
export const bulkAssignLeadsApi = (data) =>
  API.put(`/leads/bulk-assign`, data);

export const getLeadTimelineApi = (leadId) =>
  API.get(`/leads/timeline/${leadId}`);